/* EL (22-09): trocar cor/tamanho dentro do carrinho lateral (como no carrinho antigo).
   Adiciona a variante nova por /cart/add.js e pede ao cart-items-component do tema para pôr a linha antiga a 0 —
   é ele que refaz a secção (morph), por isso o resto do carrinho atualiza-se sozinho. */
(function () {
  if (window.__elCartVariant) return; window.__elCartVariant = true;
  // em captura: o cart-items-component do tema apanha todos os 'change' lá dentro e trata-os como quantidade
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('.el-cart-opt') : null;
    if (!sel) return;
    e.stopPropagation();
    var caixa = sel.closest('.el-cart-opts');
    var escolha = Array.prototype.map.call(caixa.querySelectorAll('.el-cart-opt'), function (s) { return s.value; });
    var variantes = JSON.parse(caixa.querySelector('.el-cart-variants').textContent);
    var v = variantes.find(function (x) { return x.o.every(function (o, i) { return o === escolha[i]; }); });
    var atual = Number(caixa.dataset.elVariant);
    var aviso = caixa.querySelector('.el-cart-opts__msg');
    if (!v || !v.a) {
      if (aviso) aviso.textContent = v ? 'Sold out in this option' : 'Not available in this combination';
      return;
    }
    if (aviso) aviso.textContent = '';
    if (v.id === atual) return;
    var linha = caixa.closest('.cart-items__table-row');
    var chave = linha ? linha.getAttribute('data-key') : null;
    if (!chave) { location.reload(); return; }
    var input = linha ? linha.querySelector('input[type="number"], input[name^="updates"]') : null;
    var qtd = input ? (parseInt(input.value, 10) || 1) : 1;
    var comp = caixa.closest('cart-items-component');
    caixa.classList.add('is-busy');
    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qtd }] }) })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r.status && r.status >= 400) throw new Error(r.description || 'erro');
        // a Shopify mete a linha nova no TOPO do carrinho — a linha antiga muda de número. Procura-se pela key.
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var idx = cart.items.findIndex(function (it) { return it.key === chave; });
          if (idx < 0) { location.reload(); return; }
          if (comp && typeof comp.updateQuantity === 'function') {
            comp.updateQuantity({ line: idx + 1, quantity: 0, action: 'change' });
          } else {
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: idx + 1, quantity: 0 }) }).then(function () { location.reload(); });
          }
        });
        if (false) {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: Number(caixa.dataset.elLine), quantity: 0 }) }).then(function () { location.reload(); });
        }
      })
      .catch(function () { caixa.classList.remove('is-busy'); if (aviso) aviso.textContent = 'Could not update. Try again.'; });
  }, true);
})();
